import React from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { MapPin, Phone, CheckCircle2, ShieldCheck, AlertTriangle, ArrowRight, Search, Wrench, ClipboardCheck, Trash2 } from 'lucide-react';
export function DominionValley() {
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-1198">
      <TopBar data-id="element-1199" />
      <Header data-id="element-1200" />
      <Navigation data-id="element-1201" />

      <main className="flex-grow" data-id="element-1202">
        {/* Hero */}
        <section className="bg-white border-b border-brand-border py-16 lg:py-24" data-id="element-1203">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1204">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1205">
              <div data-id="element-1206">
                <span className="inline-flex items-center gap-2 py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-1207">
                  <MapPin size={14} data-id="element-1208" /> Haymarket, VA · Community Service
                </span>
                <h1 className="text-4xl lg:text-5xl font-serif font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-1209">
                  Regency at Dominion Valley Mailbox Services
                </h1>
                <p className="text-lg text-brand-muted leading-relaxed mb-6" data-id="element-1210">
                  MidAtlantic Mailbox, Inc. proudly serves the Regency at
                  Dominion Valley community. We provide model identification,
                  repairs, replacement parts, and HOA-approved mailbox
                  installations for homeowners.
                </p>
                <div className="flex flex-col sm:flex-row gap-4" data-id="element-1211">
                  <a href="tel:301-620-7585" className="bg-brand-maroon hover:bg-brand-maroonDark text-white px-6 py-3.5 rounded-md font-bold transition-colors shadow-sm flex items-center justify-center gap-2" data-id="element-1212">
                    <Phone size={18} data-id="element-1213" /> Call 301-620-7585
                  </a>
                  <a href="/3947.html" className="bg-white border border-brand-border hover:border-brand-maroon text-brand-charcoal px-6 py-3.5 rounded-md font-bold transition-colors shadow-sm flex items-center justify-center gap-2" data-id="element-1214">
                    View Our Services <ArrowRight size={16} data-id="element-1215" />
                  </a>
                </div>
              </div>
              <div className="relative" data-id="element-1216">
                <div className="rounded-2xl overflow-hidden shadow-lg border border-brand-border" data-id="element-1217">
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/Regency%20at%20Dominion%20Valley%20Community%20.png" alt="Regency at Dominion Valley community" className="w-full h-full object-cover" data-id="element-1218" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* HOA Approved Model */}
        <section className="py-12 bg-brand-goldWash border-b border-brand-border" data-id="element-1219">
          <div className="max-w-5xl mx-auto px-4" data-id="element-1220">
            <div className="bg-white rounded-2xl border border-brand-border shadow-sm p-8 flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-1221">
              <div className="w-20 h-20 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center shrink-0" data-id="element-1222">
                <ShieldCheck size={40} data-id="element-1223" />
              </div>
              <div data-id="element-1224">
                <span className="text-brand-maroon font-bold tracking-wider uppercase text-xs mb-2 block" data-id="element-1225">
                  HOA Approved Mailbox System
                </span>
                <h2 className="text-2xl lg:text-3xl font-serif font-bold text-brand-charcoal mb-2" data-id="element-1226">
                  Imperial Model C1-6425-7 in Black
                </h2>
                <p className="text-brand-muted" data-id="element-1227">
                  This is the official mailbox system approved by the Dominion
                  Valley HOA, provided and serviced by MidAtlantic Mailbox, Inc.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Homeowners Notice */}
        <section className="py-12 bg-white border-b border-brand-border" data-id="element-1228">
          <div className="max-w-5xl mx-auto px-4" data-id="element-1229">
            <div className="bg-brand-maroon/5 border border-brand-maroon/20 rounded-xl p-6 lg:p-8 flex flex-col md:flex-row gap-6 items-start" data-id="element-1230">
              <div className="w-12 h-12 rounded-full bg-brand-maroon/10 text-brand-maroon flex items-center justify-center shrink-0" data-id="element-1231">
                <AlertTriangle size={24} data-id="element-1232" />
              </div>
              <div data-id="element-1233">
                <h2 className="text-xl font-bold text-brand-maroon mb-3" data-id="element-1234">
                  Homeowners Notice
                </h2>
                <div className="space-y-3 text-brand-charcoal/80 leading-relaxed text-sm" data-id="element-1235">
                  <p data-id="element-1236">
                    If you have questions about your mailbox, need a repair or a
                    replacement part, or are looking to update your mailbox
                    system, please call{' '}
                    <a href="tel:301-620-7585" className="font-semibold text-brand-maroon hover:underline" data-id="element-1237">
                      301-620-7585
                    </a>
                    .
                  </p>
                  <p data-id="element-1238">
                    Your current model required by the Dominion Valley HOA is
                    not listed for sale online, as there are many models with a
                    similar design and a different mounting mechanism.
                  </p>
                  <p className="font-semibold text-brand-charcoal" data-id="element-1239">
                    Please note: as of 2021–2022, homeowners are instructed to
                    update their old mailbox model to the correct mailbox model
                    if they are in need of a repair or a replacement.
                  </p>
                  <p data-id="element-1240">
                    Thank you for letting MidAtlantic Mailbox, Inc. serve you!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Bracket Comparison */}
        <section className="py-16 bg-brand-background border-b border-brand-border" data-id="element-1241">
          <div className="max-w-5xl mx-auto px-4" data-id="element-1242">
            <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-1243">
              <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-1244">
                The Community Is Transferring Models
              </h2>
              <p className="text-brand-muted leading-relaxed" data-id="element-1245">
                Below is a comparison of the old bracket mounting mechanism with
                the new bracket model. If you need a replacement mailbox
                bracket, call your mailbox experts at{' '}
                <a href="tel:301-620-7585" className="text-brand-maroon font-semibold hover:underline" data-id="element-1246">
                  301-620-7585
                </a>{' '}
                to ensure you have the correct model — the posts themselves are
                drilled to accommodate a certain mounting style.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1247">
              <div className="bg-white rounded-xl border border-brand-border shadow-sm overflow-hidden" data-id="element-1248">
                <div className="aspect-video bg-brand-goldWash flex items-center justify-center p-6" data-id="element-1249">
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/Large%20scroll%20Old%20Bracket.png" alt="Old large scroll bracket mounting mechanism" className="max-h-full object-contain" data-id="element-1250" />
                </div>
                <div className="p-5 text-center" data-id="element-1251">
                  <span className="text-xs font-bold uppercase tracking-wide text-brand-muted" data-id="element-1252">
                    Previous Model
                  </span>
                  <h3 className="font-bold text-brand-charcoal text-lg mt-1" data-id="element-1253">
                    Large Scroll (Old Bracket)
                  </h3>
                </div>
              </div>
              <div className="bg-white rounded-xl border border-brand-maroon/30 shadow-sm overflow-hidden ring-1 ring-brand-maroon/10" data-id="element-1254">
                <div className="aspect-video bg-brand-goldWash flex items-center justify-center p-6" data-id="element-1255">
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/Y%20Bracket.png" alt="New Y bracket mounting mechanism" className="max-h-full object-contain" data-id="element-1256" />
                </div>
                <div className="p-5 text-center" data-id="element-1257">
                  <span className="text-xs font-bold uppercase tracking-wide text-brand-maroon" data-id="element-1258">
                    Current Model
                  </span>
                  <h3 className="font-bold text-brand-charcoal text-lg mt-1" data-id="element-1259">
                    Y Bracket (New Bracket)
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Service Callouts */}
        <section className="py-16 bg-white border-b border-brand-border" data-id="element-1260">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1261">
            <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-1262">
              <span className="text-brand-maroon font-bold tracking-wider uppercase text-xs mb-2 block" data-id="element-1263">
                Your Mailbox, Our Mission
              </span>
              <h2 className="text-3xl font-serif font-bold text-brand-charcoal" data-id="element-1264">
                Your Mailbox Experts Are Here to Help
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-1265">
              {[{
              icon: Search,
              label: 'Model Identification'
            }, {
              icon: AlertTriangle,
              label: 'Damaged Mailbox Diagnostic'
            }, {
              icon: ClipboardCheck,
              label: 'Free Estimating Service'
            }, {
              icon: Wrench,
              label: 'Installation per USPS Guidelines'
            }, {
              icon: Trash2,
              label: 'Removal & Disposal of Old Mailbox'
            }].map(({
              icon: Icon,
              label
            }) => <div key={label} className="bg-brand-background p-6 rounded-xl border border-brand-border flex flex-col items-center text-center" data-id="element-1266">
                  <div className="w-12 h-12 rounded-full bg-brand-goldSoft text-brand-maroon flex items-center justify-center mb-4" data-id="element-1267">
                    <Icon size={22} data-id="element-1268" />
                  </div>
                  <p className="font-semibold text-brand-charcoal text-sm" data-id="element-1269">
                    {label}
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        {/* About Community & Us */}
        <section className="py-16 lg:py-24 bg-brand-background border-b border-brand-border" data-id="element-1270">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1271">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-1272">
              <div className="bg-white rounded-2xl border border-brand-border shadow-sm p-8" data-id="element-1273">
                <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-1274">
                  About the Community
                </h2>
                <p className="text-brand-muted leading-relaxed mb-4" data-id="element-1275">
                  Regency at Dominion Valley is a 55-and-over active adult
                  community in Haymarket, VA. Within the community, MidAtlantic
                  Mailbox, Inc. provides service for the mailboxes of
                  single-family homes and homeowners.
                </p>
                <p className="text-brand-muted leading-relaxed" data-id="element-1276">
                  After development, the HOA reached out to our family-owned &
                  operated company in 2017, and we have been taking care of your
                  mailboxes ever since!
                </p>
              </div>
              <div className="bg-white rounded-2xl border border-brand-border shadow-sm p-8" data-id="element-1277">
                <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-1278">
                  About Us
                </h2>
                <p className="text-brand-muted leading-relaxed mb-6" data-id="element-1279">
                  Our matriarch, Anne Ingram, launched this woman-owned &
                  operated company in 2003. Over the next 22 years, she earned
                  the reputation in the Mid-Atlantic Region as the "Mailbox
                  Lady," and now she's looking to pass the torch to her
                  daughters. In typical start-up fashion, her now-booming
                  business began in her garage with a determination to make her
                  mark on the mailbox industry and help the community navigate a
                  confusing sector.
                </p>
                <div className="flex gap-4" data-id="element-1280">
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/woman%20owned%20badge.png" alt="Woman Owned Business" className="h-14 object-contain" data-id="element-1281" />
                  <img src="https://drwzpk38qkpfb.cloudfront.net/www.midatlanticmailboxes.com/uploaded/images/Redesign/family%20owned%20badge.png" alt="Family Owned Business" className="h-14 object-contain" data-id="element-1282" />
                </div>
                <a href="/7.html" className="inline-flex items-center mt-6 text-brand-maroon font-semibold hover:text-brand-maroonDark transition-colors" data-id="element-1283">
                  Learn more about us <ArrowRight size={16} className="ml-1" data-id="element-1284" />
                </a>
              </div>
            </div>

            {/* Trust strip */}
            <div className="mt-10 bg-white rounded-2xl border border-brand-border shadow-sm p-6" data-id="element-1285">
              <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-center" data-id="element-1286">
                {['First Impressions Start at the Curb', 'Top-Rated Manufacturers', 'Family Owned & Operated', '22 Years of Trusted Service', 'Expert Industry Knowledge'].map(item => <div key={item} className="flex flex-col items-center gap-2" data-id="element-1287">
                    <CheckCircle2 size={20} className="text-brand-maroon" data-id="element-1288" />
                    <p className="text-xs font-semibold text-brand-charcoal leading-snug" data-id="element-1289">
                      {item}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 lg:py-20 bg-brand-charcoal text-center" data-id="element-1290">
          <div className="max-w-3xl mx-auto px-4" data-id="element-1291">
            <h2 className="text-3xl font-serif font-bold text-white mb-4" data-id="element-1292">
              Need a Repair or Replacement?
            </h2>
            <p className="text-gray-300 mb-8" data-id="element-1293">
              Call your Dominion Valley mailbox experts to confirm the correct
              HOA-approved model, brackets, and mounting style before you order.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1294">
              <a href="tel:301-620-7585" className="bg-brand-gold hover:bg-brand-gold/90 text-brand-charcoal px-8 py-3.5 rounded-md font-bold transition-colors shadow-sm w-full sm:w-auto flex items-center justify-center gap-2" data-id="element-1295">
                <Phone size={18} data-id="element-1296" /> Call 301-620-7585
              </a>
              <a href="/5.html" className="bg-transparent border-2 border-white hover:bg-white hover:text-brand-charcoal text-white px-8 py-3.5 rounded-md font-bold transition-colors shadow-sm w-full sm:w-auto" data-id="element-1297">
                Contact Us
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1298" />
      <MobileStickyBar data-id="element-1299" />
    </div>;
}